import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { api } from '../api';

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const [isFirst, setIsFirst] = useState(false);

  useEffect(() => {
    api.bootstrap()
      .then(({ hasUsers }) => setIsFirst(!hasUsers))
      .catch(() => {});
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (password !== password2) {
      setError('Sifreler eslesmiyor');
      return;
    }
    if (password.length < 6) {
      setError('Sifre en az 6 karakter olmali');
      return;
    }
    setBusy(true); setError(null);
    try {
      await register(username, password);
      navigate('/', { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-shell">
      <form className="auth-card" onSubmit={onSubmit}>
        <h1 className="auth-title">PauOtomotiv</h1>
        <p className="auth-subtitle">Yeni Hesap</p>

        {isFirst && (
          <div className="auth-info">
            <strong>İlk kullanıcı sensin.</strong> Kayıt olduğunda otomatik olarak admin yetkisi verilecek.
          </div>
        )}

        <label className="auth-field">
          <span>Kullanici Adi (≥3 karakter)</span>
          <input
            type="text"
            value={username}
            onChange={e => setUsername(e.target.value)}
            minLength={3}
            autoFocus
            required
          />
        </label>

        <label className="auth-field">
          <span>Sifre (≥6 karakter)</span>
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            minLength={6}
            required
          />
        </label>

        <label className="auth-field">
          <span>Sifre (Tekrar)</span>
          <input
            type="password"
            value={password2}
            onChange={e => setPassword2(e.target.value)}
            minLength={6}
            required
          />
        </label>

        {error && <div className="auth-error">{error}</div>}

        <button type="submit" className="auth-submit" disabled={busy}>
          {busy ? 'Kaydoluyor...' : 'Kayit Ol'}
        </button>

        <div className="auth-footer">
          Zaten hesabin var mi? <Link to="/login">Giris yap</Link>
        </div>
      </form>
    </div>
  );
}
